export default {
  'DATE.JAN': '一月',
  'DATE.FEB': '二月',
  'DATE.MAR': '三月',
  'DATE.APR': '四月',
  'DATE.MAY': '五月',
  'DATE.JUN': '六月',
  'DATE.JUL': '七月',
  'DATE.AUG': '八月',
  'DATE.SEP': '九月',
  'DATE.OCT': '十月',
  'DATE.NOV': '十一月',
  'DATE.DEC': '十二月',

  'WEEK.SUN': '星期日',
  'WEEK.MON': '星期一',
  'WEEK.TUE': '星期二',
  'WEEK.WED': '星期三',
  'WEEK.THU': '星期四',
  'WEEK.FRI': '星期五',
  'WEEK.SAT': '星期六',

  'GENDER.MALE': '男性',
  'GENDER.FEMALE': '女性',
  'GENDER.OTHER': '其它',

  'MARRIAGE.SINGLE': '未婚',
  'MARRIAGE.MARRIED': '已婚',
  'MARRIAGE.DIVORCE': '離異',
  'MARRIAGE.WIDOWED': '喪偶',
  'MARRIAGE.SEPARATION': '分居',

  'OCCUPATION.FREELANCER': '自由業',
  'OCCUPATION.STUDENT': '學生',
  'OCCUPATION.CONSTRUCTION': '建築營造',
  'OCCUPATION.FINANCE': '金融商業',
  'OCCUPATION.AGRICULTURE': '農林漁牧',
  'OCCUPATION.EDUCATION': '教育文化',
  'OCCUPATION.MEDIA': '新聞傳媒',
  'OCCUPATION.RELIGION': '宗教公共',
  'OCCUPATION.HOSPITALITY': '餐旅服務',
  'OCCUPATION.TECHNOLOGY': '資訊科技',
  'OCCUPATION.SPORTS': '體育',
  'OCCUPATION.HEALTHCARE': '醫事',
  'OCCUPATION.TRANSPORTATION': '交通運輸',

  'INTEREST.OUTDOORS': '戶外活動',
  'INTEREST.SHOPPING': '購物時尚',
  'INTEREST.DINING': '餐飲美食',
  'INTEREST.TRAVEL': '旅遊',
  'INTEREST.ENTERTAINMENT': '音樂影視',
  'INTEREST.ARTS': '文化藝術',
  'INTEREST.FITNESS': '健身保健',
  'INTEREST.TECHNOLOGY': '科技',
  'INTEREST.LEARNING': '進修教育',
  'INTEREST.OTHERS': '其它',

  'DIET.CARNIVORE': '重肉食',
  'DIET.ECO_VEGETARIAN': '環保素',
  'DIET.RELIGIOUS_VEGETARIAN': '信仰素',
  'DIET.FLEXIBLE': '不拘',

  'TAIWAN.CITY': '',

  'EDUCATION.JUNIOR': '國中以下',
  'EDUCATION.SENIOR': '高中職',
  'EDUCATION.BACHELOR': '學士',
  'EDUCATION.MASTER': '碩士以上',

  'MPS.SOURCE.1': '後台',
  'MPS.SOURCE.2': '前台',
  'MPS.SOURCE.3': 'POS',
  'MPS.SOURCE.4': '系統',
  'MPS.SOURCE.5': '肚肚POS',
  'MPS.SOURCE.6': 'Eats365 POS',
  'MPS.SOURCE.7': '短網址',
  'MPS.SOURCE.8': '序號兌換',

  'MPS.EVENT.COLLECT': '獲點',
  'MPS.EVENT.REDEEM': '扣點',
  'MPS.EVENT.0': '未達發點門檻',
  'MPS.EVENT.1': '滿額發點',
  'MPS.EVENT.2': '壽星加碼',
  'MPS.EVENT.3': '會員加碼',
  'MPS.EVENT.4': '彈性發點',
  'MPS.EVENT.5': '壽星加碼',
  'MPS.EVENT.6': '會員加碼',
  'MPS.EVENT.7': '初始發點',
  'MPS.EVENT.8': '消費折抵發點',
  'MPS.EVENT.9': '接受轉贈',
  'MPS.EVENT.10': '彈性扣點',
  'MPS.EVENT.11': '現金折抵',
  'MPS.EVENT.12': '限時加碼',
  'MPS.EVENT.13': '會員推薦活動',
  'MPS.EVENT.14': '會員推薦註冊',
  'MPS.EVENT.15': '行銷活動贈點',
  'MPS.EVENT.16': '線上問卷贈點',
  'MPS.EVENT.17': '序號兌換',
  'MPS.EVENT.20': '兌換-自動轉券',
  'MPS.EVENT.21': '兌換-自由選券',
  'MPS.EVENT.30': '轉贈好友',
  'MPS.EVENT.31': '異動扣點',
  'MPS.EVENT.51': '異動發點',
  'MPS.EVENT.52': '後台補單發點',
  'MPS.EVENT.53': '取消交易-回收優惠券點數返還',
  'MPS.EVENT.54': '優惠點數',
  'MPS.EVENT.55': '生日禮',
  'MPS.EVENT.56': '入會禮',
  'MPS.EVENT.57': '升等禮',
  'MPS.EVENT.91': '取消交易-滿額發點',
  'MPS.EVENT.92': '取消交易-壽星加碼',
  'MPS.EVENT.93': '取消交易-會員加碼',
  'MPS.EVENT.94': '扣除升等禮等值點數',
  'MPS.EVENT.95': '扣除生日禮等值點數',
  'MPS.EVENT.96': '扣除優惠券等值點數',
  'MPS.EVENT.97': '取消交易-限時加碼',
  'MPS.EVENT.99': '點數逾期',
  'MPS.EVENT.100': '取消交易-行銷活動',

  'COLLECT.EVENT.0': '不符發點',
  'COLLECT.EVENT.1': '滿額發點',
  'COLLECT.EVENT.4': '彈性發點',
  'COLLECT.EVENT.10': '彈性扣點',
  'COLLECT.EVENT.20': '自動轉券',
  'COLLECT.EVENT.21': '自由選券',
  'COLLECT.EVENT.90': '取消集點',
  'COLLECT.EVENT.91': '取消交易扣點',
  'COLLECT.EVENT.92': '取消交易-自動轉券點數返還',
  'COLLECT.EVENT.93': '取消發點',
  'COLLECT.EVENT.94': '取消扣點',
} as Record<string, any>;
